export default __webpack_public_path__ + "static/media/goose_grayscale.c5c3c2ea.svg";